// removed by extract-text-webpack-plugin
module.exports = {"box":"_37TfFer8gDOLXP3_fx9BOf","shadow":"_3txuvbzFtq0w4NTlsSS1oa"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/ImagePreview/style.css
// module id = 409
// module chunks = 37